import React from 'react';
import { createRoot } from 'react-dom/client';
import './css/index.css';
import './css/fontFace.css';
import reportWebVitals from './reportWebVitals';
import {configAxiosDefault} from "./api/api";
import {Rutas} from "./routes";

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Rutas/>
    </React.StrictMode>
);

reportWebVitals();
configAxiosDefault();
